module.exports = __webpack_public_path__ + "assets/img/defultPreviewTsa.5e26db89.png";